export default {
  setLoading: (state, loading) => (state.loading = loading),
  setCategories: (state, categories) => (state.categories = categories),
  setCategoryFilter: (state, categoryFilter) =>
    (state.categoryFilter = categoryFilter),
};
